import { render, staticRenderFns } from "./StartupSearchList.vue?vue&type=template&id=754aad92&scoped=true"
import script from "./StartupSearchList.vue?vue&type=script&lang=js"
export * from "./StartupSearchList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754aad92",
  null
  
)

export default component.exports